import React from "react";
import "./styles.scss";
import { ReactComponent as ArrowUp } from "../../../../../../public/icons/upload-flow/arrow-up.svg";
import { ReactComponent as ArrowDown } from "../../../../../../public/icons/upload-flow/arrow-down.svg";
import { ReactComponent as Remove } from "../../../../../../public/icons/upload-flow/remove.svg";
import { ProgressBar } from "react-bootstrap";
import PropTypes from "prop-types";
import { findDOMNode } from "react-dom";
import { DragSource, DropTarget } from "react-dnd";
import flow from "lodash/flow";

const cardSource = {
  beginDrag(props) {
    return {
      s3_object_key: props.s3_object_key,
      index: props.index,
    };
  },
};

const cardTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }
    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    // Determine mouse position
    const clientOffset = monitor.getClientOffset();
    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;
    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%
    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }
    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }
    // Time to actually perform the action
    props.onMoveCard(dragIndex, hoverIndex);
    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

class Card extends React.Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    isDragging: PropTypes.bool.isRequired,
    s3_object_key: PropTypes.any.isRequired,
    onMoveCard: PropTypes.func.isRequired,
    className: PropTypes.string,
  };

  sortCardByArrow = (action, isDisable, index) => () => {
    if (isDisable) return;
    if (action === "up") {
      this.props.onMoveCard(index, index - 1);
    } else {
      this.props.onMoveCard(index, index + 1);
    }
  };

  render() {
    const {
      new_track,
      index,
      progress,
      totalTracks,
      isDragging,
      connectDragSource,
      connectDropTarget,
      onRemoveTrack,
      className = "",
    } = this.props;

    const opacity = isDragging ? 0 : 1;
    const disableUpArrow = index === 0;
    const disableDownArrow = totalTracks - 1 === index;

    return (
      connectDragSource &&
      connectDropTarget &&
      connectDragSource(
        connectDropTarget(
          <section
            style={{ opacity }}
            key={new_track.s3_object_key}
            className={`track d-flex flex-row w-100 ${className}`}
          >
            <div className="d-flex flex-column">
              <div className="track-sort d-flex flex-column justify-content-around align-items-center">
                <ArrowUp
                  className={`${disableUpArrow ? "disabled" : ""}`}
                  onClick={this.sortCardByArrow("up", disableUpArrow, index)}
                />
                <ArrowDown
                  className={`${disableDownArrow ? "disabled" : ""}`}
                  onClick={this.sortCardByArrow(
                    "down",
                    disableDownArrow,
                    index
                  )}
                />
              </div>
            </div>
            <div className="track-details">
              <p className="mb-2">{new_track.file.name}</p>
              {new_track.progress > -1 && (
                <ProgressBar
                  className="track-uploader-progress"
                  now={new_track.progress}
                  label={
                    new_track.progress === 100
                      ? "Upload Completed"
                      : `${Math.round(new_track.progress)}% UPLOADED`
                  }
                />
              )}
            </div>
            <div className="d-flex flex-column justify-content-end align-items-center">
              <Remove onClick={() => onRemoveTrack(new_track)} />
            </div>
          </section>
        )
      )
    );
  }
}

export default flow(
  DragSource("card", cardSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })),
  DropTarget("card", cardTarget, (connect) => ({
    connectDropTarget: connect.dropTarget(),
  }))
)(Card);
